import { useContext } from 'react';

import { DocumentSettingsContext } from 'components/editor/SidePanel/DocumentSettings/DocumentDesignSettings/DocumentSettingsContext';
import type { PageSize } from 'components/editor/shared/gridConfig';
import { computeEffectivePageSize } from './computeEffectivePageSize';
import { selectContentType } from '../components/editor/grid/reduxStore/documentSettingsSlice';
import { useAppSelector } from '../components/editor/grid/reduxStore/Store';

// Single source of truth for the editor canvas page size (width/height, already oriented).
export function useEffectivePageSize(): PageSize {
  const { documentSettings, sectionStyles } = useContext(DocumentSettingsContext);
  const contentType = useAppSelector(selectContentType);

  return computeEffectivePageSize(contentType, documentSettings, sectionStyles);
}
